import { useRouter, useRoute } from 'vue-router';
import { remindScroll } from '@/common/utils/ScrollManager';
import { useStore } from 'vuex';

export function useNavigator() {
  const router = useRouter();
  const route = useRoute();
  const store = useStore();

  const prepareStoreMainNavigation = (isRemainScroll = false) => {
    if (isRemainScroll) {
      // 기존 remindScroll(path) 호출
      remindScroll(route.path);
    }

    store.commit('layout/setFromStorePath', route.path);
    // 상점 진입 시 기존 카테고리 및 상품 초기화
    store.commit('store/setAllProducts');
    store.commit('store/setProducts');
  };

  /**
   * 페이지 이동 시 스크롤 상태를 유지할지 여부를 선택할 수 있는 유틸
   * @param {string|object} destination - 이동할 경로 혹은 route 객체
   * @param isRemainScroll
   * @param {boolean} [options.remainScroll=false] - 스크롤 유지 여부
   */
  const toStoreMain = (destination, isRemainScroll = false) => {
    prepareStoreMainNavigation(isRemainScroll);
    router.push(destination);
  };

  const replaceToStoreMain = (destination, isRemainScroll = false) => {
    prepareStoreMainNavigation(isRemainScroll);
    router.replace(destination);
  };

  return { toStoreMain, replaceToStoreMain };
}
